import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PermissionServiceService {
  private permissions: any[] = [];

  constructor() {
    this.loadPermissions();
  }

  // Load permissions from localStorage
  loadPermissions(): void {
    const userPermissions = localStorage.getItem('user_permissions');
    if (userPermissions) {
      this.permissions = JSON.parse(userPermissions);
    }
  }

  // Check if the user has a specific permission for a menu
  hasPermission(menuId: number, action: 'new' | 'edit' | 'delete' | 'view'): boolean {
    
    const permission = this.permissions.find((perm) => +perm.menu_id === menuId); // Convert string to number
    return permission ? permission[`${action}_id`] === 1 : false; // Permissions are strings in your array
  }

  // Check if the user has any permission for a menu
  hasAnyPermission(menuId: number): boolean {
    const permission = this.permissions.find((perm) => +perm.menu_id === menuId); // Convert string to number
    return permission
      ? permission.new_id === 1 || permission.edit_id === 1 || permission.delete_id === 1 || permission.view_id === 1
      : false;
  }
}
